// ATHLETXWEAR — Sneaker Bar Theme JS

(function(){
'use strict';

// ---- Cart ----
const CartAPI = {
  async get() { const r = await fetch('/cart.js'); return r.json(); },
  async add(id, qty=1) {
    const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id, quantity:qty}) });
    return r.json();
  },
  async update(updates) {
    const r = await fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates}) });
    return r.json();
  },
  async remove(id) { return this.update({[id]:0}); }
};

// ---- Toast ----
function toast(msg, duration=3000) {
  const el = document.createElement('div');
  el.className = 'toast';
  el.textContent = msg;
  const wrap = document.getElementById('ax-toast');
  if (!wrap) return;
  wrap.appendChild(el);
  setTimeout(() => el.remove(), duration);
}

// ---- Cart drawer ----
const cartDrawer = document.getElementById('cart-drawer');
const cartOverlay = document.querySelector('.cart-overlay');
const cartCount = document.querySelectorAll('.cart-count');

function openCart() {
  cartDrawer?.classList.add('open');
  cartOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  cartDrawer?.classList.remove('open');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow = '';
}

async function renderCart() {
  const cart = await CartAPI.get();
  updateCartCount(cart.item_count);
  const body = document.querySelector('.cart-drawer__body');
  const footer = document.querySelector('.cart-drawer__footer');
  if (!body) return;
  if (cart.item_count === 0) {
    body.innerHTML = `<div style="padding:40px 0;text-align:center;color:var(--gray-400)">
      <p style="font-size:12px;letter-spacing:.1em;text-transform:uppercase;margin-bottom:12px">Your cart is empty</p>
      <a href="/collections/all" class="btn btn--outline" style="display:inline-flex;gap:6px" onclick="closeCart()">Start Shopping</a>
    </div>`;
    if (footer) footer.style.display = 'none';
  } else {
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__img" src="${item.image}" alt="${item.product_title}">
        <div style="flex:1;min-width:0">
          <p class="cart-item__name">${item.product_title}</p>
          <p class="cart-item__meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <div style="display:flex;align-items:center;justify-content:space-between">
            <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
            <div style="display:flex;align-items:center;gap:12px">
              <button onclick="updateQty(${item.variant_id}, ${item.quantity - 1})" style="width:24px;height:24px;border:1px solid var(--gray-200);background:var(--white);font-size:14px;display:flex;align-items:center;justify-content:center;cursor:pointer">&minus;</button>
              <span style="font-size:13px;min-width:16px;text-align:center">${item.quantity}</span>
              <button onclick="updateQty(${item.variant_id}, ${item.quantity + 1})" style="width:24px;height:24px;border:1px solid var(--gray-200);background:var(--white);font-size:14px;display:flex;align-items:center;justify-content:center;cursor:pointer">+</button>
            </div>
          </div>
        </div>
      </div>
    `).join('');
    if (footer) {
      footer.style.display = 'block';
      const totals = footer.querySelector('.cart-totals__value');
      if (totals) totals.textContent = formatMoney(cart.total_price);
    }
  }
}

window.updateQty = async (id, qty) => {
  await CartAPI.update({[id]: Math.max(0, qty)});
  renderCart();
};

function updateCartCount(n) {
  cartCount.forEach(el => {
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-EG', {style:'currency', currency:'EGP', minimumFractionDigits:0});
}

// Cart button listeners
document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', openCart));
cartOverlay?.addEventListener('click', closeCart);
document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCart);

// ---- Search ----
const searchBar = document.getElementById('search-bar');
document.querySelectorAll('[data-search]').forEach(btn => {
  btn.addEventListener('click', () => {
    searchBar?.classList.toggle('open');
    if (searchBar?.classList.contains('open')) {
      searchBar.querySelector('input')?.focus();
    }
  });
});
document.querySelector('.search-bar__close')?.addEventListener('click', () => {
  searchBar?.classList.remove('open');
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') searchBar?.classList.remove('open'); });

// ---- Mobile nav ----
const mobileNav = document.getElementById('mobile-nav');
const mobileOverlay = document.querySelector('.mobile-overlay');
document.getElementById('hamburger')?.addEventListener('click', () => {
  mobileNav?.classList.add('open');
  mobileOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
});
[mobileOverlay, document.getElementById('mobile-nav-close')].forEach(el => {
  el?.addEventListener('click', () => {
    mobileNav?.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  });
});

// ---- Add to cart (product page) ----
document.querySelectorAll('.atc-btn').forEach(btn => {
  btn.addEventListener('click', async () => {
    const varId = btn.dataset.variantId;
    if (!varId) { toast('Please select a size'); return; }
    const original = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    try {
      await CartAPI.add(parseInt(varId));
      btn.textContent = 'Added!';
      updateCartCount((await CartAPI.get()).item_count);
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
      setTimeout(() => openCart(), 400);
    } catch {
      btn.textContent = 'Error';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
      toast('Could not add to cart');
    }
  });
});

// ---- Size selector ----
document.querySelectorAll('.size-btn:not(.unavailable)').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const atcBtn = document.querySelector('.atc-btn');
    if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
    // update price if needed
    const price = btn.dataset.price;
    const compare = btn.dataset.comparePrice;
    if (price) {
      const priceEl = document.querySelector('.product-info__price');
      if (priceEl) priceEl.textContent = formatMoney(parseInt(price));
      const compareEl = document.querySelector('.product-info__price-compare');
      if (compareEl) compareEl.style.display = compare && compare !== '0' ? '' : 'none';
    }
  });
});

// ---- Gallery thumbs ----
document.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const main = document.querySelector('.product-gallery__img');
    if (main) {
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
    }
  });
});

// ---- Accordion ----
document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const content = trigger.nextElementSibling;
    const isOpen = trigger.classList.contains('open');
    // Close all
    document.querySelectorAll('.accordion-trigger').forEach(t => {
      t.classList.remove('open');
      t.nextElementSibling?.classList.remove('open');
    });
    if (!isOpen) {
      trigger.classList.add('open');
      content?.classList.add('open');
    }
  });
});

// ---- Sidebar filter collapse ----
document.querySelectorAll('.catalog-sidebar__title').forEach(title => {
  title.addEventListener('click', () => {
    title.classList.toggle('collapsed');
    title.nextElementSibling?.classList.toggle('collapsed');
  });
});

// ---- Filter items ----
document.querySelectorAll('.filter-item').forEach(item => {
  item.addEventListener('click', () => {
    item.classList.toggle('active');
    updateActiveFilters();
  });
});

function updateActiveFilters() {
  const strip = document.querySelector('.active-filters');
  if (!strip) return;
  const active = document.querySelectorAll('.filter-item.active');
  strip.innerHTML = '';
  if (active.length > 0) {
    strip.classList.add('has-filters');
    active.forEach(item => {
      const chip = document.createElement('span');
      chip.className = 'active-filter-chip';
      chip.innerHTML = `${item.querySelector('span')?.textContent || ''} <button onclick="this.parentElement.dispatchEvent(new Event('remove'))">&#10005;</button>`;
      chip.addEventListener('remove', () => { item.classList.remove('active'); updateActiveFilters(); });
      strip.appendChild(chip);
    });
    const clear = document.createElement('button');
    clear.className = 'active-filters__clear';
    clear.textContent = 'Clear all';
    clear.onclick = () => { active.forEach(i => i.classList.remove('active')); updateActiveFilters(); };
    strip.appendChild(clear);
  } else {
    strip.classList.remove('has-filters');
  }
}

// ---- Mobile filter drawer ----
const filterDrawer = document.getElementById('filter-drawer');
document.querySelector('.mobile-filters-btn')?.addEventListener('click', () => {
  filterDrawer?.classList.add('open');
  mobileOverlay?.classList.add('open');
});
document.querySelector('.filter-drawer__close')?.addEventListener('click', () => {
  filterDrawer?.classList.remove('open');
  mobileOverlay?.classList.remove('open');
});

// ---- Catalog topbar tabs ----
document.querySelectorAll('.catalog-topbar__tab').forEach(tab => {
  tab.addEventListener('click', () => {
    document.querySelectorAll('.catalog-topbar__tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
  });
});
document.querySelectorAll('.catalog-topbar__gender').forEach(g => {
  g.addEventListener('click', () => {
    document.querySelectorAll('.catalog-topbar__gender').forEach(t => t.classList.remove('active'));
    g.classList.add('active');
  });
});

// ---- Wishlist (local) ----
window.toggleWish = (id) => {
  let list = JSON.parse(localStorage.getItem('ax_wish') || '[]');
  if (list.includes(id)) { list = list.filter(i => i !== id); } else { list.push(id); }
  localStorage.setItem('ax_wish', JSON.stringify(list));
  toast(list.includes(id) ? 'Saved to wishlist' : 'Removed from wishlist');
};

// ---- Init ----
(async () => {
  try {
    const cart = await CartAPI.get();
    updateCartCount(cart.item_count);
  } catch {}
})();

// Mark active nav links
const path = window.location.pathname;
document.querySelectorAll('.site-header__nav a').forEach(a => {
  if (a.getAttribute('href') === path) a.classList.add('active');
});

})();
